import React, { useEffect, useRef, useState } from "react";

const Digitalfactoryabout = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (imageRef.current) observer.observe(imageRef.current);
    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  return (
    <div className="industrial-container">
      <style>
        {`
          .industrial-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 40px 5%;
            background-color: white;
            flex-wrap: wrap;
          }
          .industrial-text {
            width: 50%;
            padding-left: 40px;
            text-align: left;
          }
          .industrial-title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
            color: black;
          }
          .industrial-desc {
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: justify;
            color: black;
          }
          .industrial-image-section {
            width: 45%;
            text-align: center;
          }
          .industrial-image {
            width: 100%;
            max-width: 700px;
            height: auto;
            border-radius: 8px;
          }

          /* Animation styles */
          .slide-in-left {
            opacity: 0;
            transform: translateX(-50px);
            transition: all 1s ease-in-out;
          }
          .slide-in-right {
            opacity: 0;
            transform: translateX(50px);
            transition: all 1s ease-in-out;
          }
          .visible {
            opacity: 1;
            transform: translateX(0);
          }

          /* Responsive */
          @media (max-width: 1024px) {
            .industrial-title {
              font-size: 28px;
            }
            .industrial-desc {
              font-size: 15px;
            }
          }
          @media (max-width: 768px) {
            .industrial-container {
              flex-direction: column;
              padding: 20px;
            }
            .industrial-text {
              width: 100%;
              padding-left: 0;
              order: 2;
            }
            .industrial-image-section {
              width: 100%;
              order: 1;
              margin-bottom: 30px;
            }
            .industrial-title {
              font-size: 26px;
              text-align: center;
            }
            .industrial-desc {
              font-size: 14px;
              text-align: left;
            }
          }
          @media (max-width: 480px) {
            .industrial-title {
              font-size: 22px;
            }
            .industrial-desc {
              font-size: 13px;
            }
          }
        `}
      </style>

      {/* Image Section */}
      <div
        ref={imageRef}
        className={`industrial-image-section slide-in-left ${
          isVisible ? "visible" : ""
        }`}
      >
        <img
          src="/image/11ac9dcb-48b3-4f61-a86b-1d5204169738_removalai_preview.png"
          alt="Industrial Automation"
          className="industrial-image"
        />
      </div>

      {/* Text Section */}
      <div
        ref={textRef}
        className={`industrial-text slide-in-right ${
          isVisible ? "visible" : ""
        }`}
      >
       <h2 className="industrial-title">
  Driving Brand Success with Creative Graphic Design Solutions
</h2>
<p className="industrial-desc">
  Our graphic design solutions help brands create a powerful visual identity, communicate their message effectively, and leave a lasting impression. From eye-catching logos and engaging social media creatives to professional brochures and brand guidelines, we bring your ideas to life with creativity and precision.
</p>
<p className="industrial-desc">
  By combining artistic vision with strategic design thinking, we craft visuals that resonate with your target audience. Our team ensures that every design element reflects your brand’s personality while maintaining consistency across all platforms.
</p>
<p className="industrial-desc">
  Whether you’re in retail, hospitality, healthcare, or any other industry, we deliver customized graphic design solutions that enhance brand recognition, improve customer engagement, and give you a competitive edge in the market.
</p>

      </div>
    </div>
  );
};

export default Digitalfactoryabout;
